const GET_RELATED_ARTICLES_LOADING =
  'related-articles/GET_RELATED_ARTICLES_LOADING';
const GET_RELATED_ARTICLES_SUCCESS =
  'related-articles/GET_RELATED_ARTICLES_SUCCESS';
const GET_RELATED_ARTICLES_ERROR =
  'related-articles/GET_RELATED_ARTICLES_ERROR';

export {
  GET_RELATED_ARTICLES_LOADING,
  GET_RELATED_ARTICLES_SUCCESS,
  GET_RELATED_ARTICLES_ERROR
};
